import classNames from "classnames";
import { useCallback, useMemo } from "react";
import { AppMenu } from "@/shared/Components";
import { type ContactsFilterProps, getSideMenuItems } from "@/entities/contacts-filters/model";
import { PersonGroup } from "@/services/api/entities/person/types";
import styles from "./styles.module.scss";

export const ContactsFiltersDesktop = ({
  setFilter,
  groupFilter,
  ...props
}: ContactsFilterProps) => {
  const menuItems = useMemo(() => getSideMenuItems(setFilter), [setFilter]);

  const getActiveKey = useCallback(() => {
    switch (groupFilter) {
      case null:
        return ["1"];
      case PersonGroup.FAMILY:
        return ["2"];
      case PersonGroup.FRIENDS:
        return ["3"];
      case PersonGroup.COLLEAGUES:
        return ["4"];
      case PersonGroup.BUSINESS:
        return ["5"];
      case PersonGroup.OTHER:
        return ["6"];
      default:
        return ["1"];
    }
  }, [groupFilter]);

  return (
    <div className={styles.root}>
      <AppMenu
        defaultSelectedKeys={["1"]}
        selectedKeys={getActiveKey()}
        items={menuItems}
        className={classNames(styles.menu)}
        {...props}
      />
    </div>
  );
};
